import { fetchGetJson } from '../../services/fetch-get-json'
import { getParam } from '../../helpers/parameters'
import { attachBearerToken } from '../../services/attach-bearer-token'

export const fetchCustomerApi = async (custOverride = '') => {
  const customer = await getCustomer(custOverride)

  const academyApiUrl = await getParam('academyApiUrl')
  
  return fetchGetJson(
    `${academyApiUrl}/retrieve-cust?getconfig=1` +
      `&requesting-domain=${customer}`,
    await attachBearerToken({ method: 'GET' })
  )
}


export const fetchOptionsApi = async (customer, lang) => {
  const url = await getParam('custOptionsApiUrl')
  const path = `${url}/acad/${customer}?language=${lang}`
  return fetchGetJson(path)
}

const getCustomer = async custOverride => {
  if (custOverride) {
    const allowCustomerOverride = await getParam('allowCustomerOverride')
    if (allowCustomerOverride === 'true') return custOverride
  }
  return window.location.host
}



// WEBPACK FOOTER //
// ./src/containers/App/services.js